import Vue from 'vue'
 
import { ACCESS_TOKEN, USER_NAME, USER_INFO, USER_AUTH, UI_CACHE_DB_DICT_DATA, TENANT_ID, FIRMWARE_PERMISSIONS } from "@/store/mutation-types" 


// 递归判断路由权限
function filterAsyncRouter(asyncRouterMap, authRouters) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (authRouters.find(item => item.resourceUri == (route.path)) || route.path == "/" || route.path == "*") {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, authRouters)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

// 获取第一个可跳转的页面
function getToPath(routerArr) {
  if (routerArr.length == 0) {
    return "/"
  } else {
    if (routerArr[0]?.list?.length > 0 && routerArr[0].list.every(v => v.resourceType < 2)) {
      return getToPath(routerArr[0].list)
    } else {
      return routerArr[0].resourceUri
    }
  }
}
// 根据类型获取菜单/按钮数组
function getAuthByType(arr, typeArr) {
  let res = [];
  arr.forEach((item) => {
    if (item.list && item.list.length > 0) {
      if (typeArr.includes(item.resourceType)) {
        res.push(item, ...getAuthByType(item.list, typeArr))
      } else {
        res.push(...getAuthByType(item.list, typeArr))
      }
    } else {
      if (typeArr.includes(item.resourceType)) {
        res.push(item)
      }
    }
  })
  return res
}

const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    tenantid: '',
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {},
    userId: '',
    // 根据 token 是否存在来判断登录状态（使用实际的 token 键名）
    isLoggedIn: !!(localStorage.getItem('token') || sessionStorage.getItem('token'))
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TENANT: (state, id) => {
      state.tenantid = id
    },
    SET_LOGIN_STATE: (state, isLoggedIn) => { // 添加登录状态的 mutation
      state.isLoggedIn = isLoggedIn
      // 不再使用单独的 isLoggedIn 标记，而是依赖 token 的存在
    }
  },

  actions: {
    // 校验手机号
    verifyCodeHandle({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        verifyCode(params).then(response => {
          if (response.code == 200) {
            const userInfo = JSON.parse(sessionStorage.getItem("USER_INFO"));
            Vue.ls.set(USER_NAME, userInfo.username)
            Vue.ls.set(USER_INFO, userInfo) // 设置不过期
            // dispatch('GetPermissionList').then(res => {
            //   const userInfo = JSON.parse(sessionStorage.getItem("USER_INFO"));
            // })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.code == 200) {
            const userInfo = response.data 
            Vue.ls.set(USER_NAME, userInfo.username)
            Vue.ls.set(USER_INFO, userInfo) // 过期时间：7 * 24 * 60 * 60 * 1000
            commit('SET_LOGIN_STATE', true) // 设置登录状态
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetPermissionList({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 安全获取 userId，避免 JSON.parse 错误
        let userId = state.userId || localStorage.getItem('roUserId')
        if (!userId) {
            try {
              const userInfoStr = sessionStorage.getItem("USER_INFO")
              if (userInfoStr) {
                const userInfo = JSON.parse(userInfoStr)
                userId = userInfo && userInfo.userId
              }
            } catch (e) {
              console.error('解析 USER_INFO 失败:', e)
              // 尝试从 Vue.ls 获取
              try {
                const userInfo = Vue.ls.get(USER_INFO)
                userId = userInfo && userInfo.userId
              } catch (e2) {
                console.error('从 Vue.ls 获取 USER_INFO 失败:', e2)
              }
            }
        }
        
        if (!userId) {
          reject({ code: 10003, message: '无法获取用户ID，请重新登录' })
          return
        }

        
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        localStorage.clear();
        sessionStorage.clear();
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        commit('SET_NAME', { username: '', realname: '', welcome: '' })
        commit('SET_LOGIN_STATE', false) // 清除登录状态
        Vue.ls.remove(ACCESS_TOKEN)
        Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
        //console.log('logoutToken: '+ logoutToken)
        logout().then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
  }
}

export default user